let config = {};

export const setConfig = configs => {
  config = { ...config, ...configs };
};

export const getConfig = key => {
  return config[key];
};

export const getAllConfig = () => {
  return config;
};
